import { Flex, Image, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { assets } from "../../../../assets/assets";

const SAMPLE_ADDRESS = "Otto Sverdrups Plass 4, 1337 Sandvika";
const SAMPLE_DISTANCE = "15km";

export const Location = () => {
  const { t } = useTranslation();
  return (
    <Flex
      flexDirection="column"
      alignItems="start"
      justifyContent="start"
      borderRadius="lg"
      bg="smBackground"
      w="full"
      h="auto"
      border="1px solid"
      borderColor="smBorder"
      p="6"
    >
      <Flex>
        <Text fontSize={"md"} fontWeight="bold" color="smOrgCardHeading">
          {t("Location")}
        </Text>
      </Flex>
      <Flex flexDirection={"column"}>
        <Flex mt="5px">
          <Link to="https://vg.no" target={"_blank"}>
            <Text color="blue.500">{SAMPLE_ADDRESS}</Text>
          </Link>
        </Flex>

        <Flex mt="5px">
          {" "}
          <Text fontWeight={"bold"}>{t("Distance")}:</Text>
          <Text ml="4px">{SAMPLE_DISTANCE}</Text>
        </Flex>
      </Flex>
      <Flex mt="10px">
        <Image src={assets.map} alt={t("Map") ?? ""} w="100%" h="auto" />
      </Flex>
    </Flex>
  );
};
